import { authenticationService } from 'src/config/rootService';

import { Credentials } from '../models/auth';
import { appClient } from 'src/config/apollo';
import { appClient as appClientV3 } from 'src/config/apolloV3';

interface AuthenticationState {
    isAuthenticated: boolean;
    isAuthenticating: boolean;
    justSignedOut: boolean;
    shouldValidateAuthData: boolean;
    errorMessage: string;
}

export const authentication = {
    state: {
        isAuthenticated: false,
        isAuthenticating: false,
        justSignedOut: false,
        shouldValidateAuthData:
            authenticationService && authenticationService.authData ? true : false,
        errorMessage: '',
    },
    reducers: {
        authenticating: (state: AuthenticationState): AuthenticationState => {
            return {
                ...state,
                isAuthenticating: true,
                shouldValidateAuthData: false,
            };
        },
        authenticate: (state: AuthenticationState): AuthenticationState => {
            state.isAuthenticated = true;
            state.shouldValidateAuthData = false;
            state.isAuthenticating = false;

            return state;
        },
        finishSignOut: (state: AuthenticationState): AuthenticationState => {
            state.justSignedOut = false;

            return state;
        },
        logout: (state: AuthenticationState): AuthenticationState => {
            state.isAuthenticated = false;
            state.shouldValidateAuthData = false;
            state.isAuthenticating = false;
            state.justSignedOut = true;

            authenticationService.logout();

            return state;
        },
        setErrorMessage: (
            state: AuthenticationState,
            errorMessage: string,
        ): AuthenticationState => {
            state.errorMessage = errorMessage;

            return state;
        },
    },
    effects: dispatch => ({
        async login(credentials: Credentials): Promise<void> {
            try {
                dispatch.authentication.setErrorMessage('');

                await authenticationService.login(credentials);

                dispatch.authentication.authenticate();
            } catch (error) {
                dispatch.authentication.setErrorMessage(error);
            }
        },
        async validateAuthData(): Promise<void> {
            dispatch.authentication.authenticating();

            try {
                await authenticationService.refresh(true);

                dispatch.authentication.authenticate();
            } catch {
                dispatch.authentication.logout();
                appClient.clearStore();
                appClientV3.clearStore();
            }
        },
        logout() {
            dispatch.messaging.clearActiveUserUuid();
        },
    }),
};
